import styled from 'styled-components'

export const ErrorContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 16px;

	svg {
		flex-shrink: 0;
	}
`
